import React, {Component} from "react";
import LoadingScreen from "../../includes/LoadingScreen";
import UserController from "../../controller/UserController";
import APIController from "../../controller/APIController";
import {faArrowRight, faDiagramProject, faFileWord} from "@fortawesome/free-solid-svg-icons";
import PageContent from "../../includes/PageContent";
import './WorksheetListPageForTrainee.css';
import CenteredMessage from "../../includes/CenteredMessage";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Col, Container, Row} from "react-bootstrap";
import PradleAccordion from "../../components/PradleAccordion";
import DateTimeUtil from "../../util/DateTimeUtil";
import TopicKachel from "../../components/TopicKachel";
import he from "he";
import BuildingRoomTable from '../../components/tables/BuildingRoomTable';
import CourseTimespanBlock from '../../components/CourseTimespanBlock';


class WorksheetsListPageForTrainee extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isFetching: true,
            user: UserController.getUser(),
            traineeId: props.traineeId,
            worksheets: [],
            worksheetsGroupedByCourseId: {},
            worksheetsGroupedByTopicId: {},
            ltbView: props.lbtView
        }
        this.onWorksheetsUpdated = this.onWorksheetsUpdated.bind(this);
    }

    async componentDidMount() {
        try {
            let user = this.state.user;
            /*  if(this.state.traineeId !== user.id){
                alert("No Access possible");
                window.location = UserController.getMyProfileUrl();
            }*/
            const traineeId = encodeURIComponent(this.state.traineeId);
            let courses = await APIController.getWorksheetByParam("traineeId", traineeId);

            if(this.props.groupNameFilter !== undefined){
                let str = this.props.groupNameFilter;
                // Ersetzen von '*' mit '.*'
                str = str.replace(/\*/g, '.*');
                // Voranfügen von '/^' und Anhängen von '$/'
                let pattern = new RegExp("^" + str + "$");
                courses = courses.filter(obj => pattern.test(obj.name));
            }


            if(this.props.topicFilter !== undefined){
                let str = this.props.topicFilter;
                // Ersetzen von '*' mit '.*'
                str = str.replace(/\*/g, '.*');
                // Voranfügen von '/^' und Anhängen von '$/'
                let pattern = new RegExp("^" + str + "$");
                courses.forEach(function(part, index, theArray) {
                    courses[index].worksheets = courses[index].worksheets.filter(obj => pattern.test(obj.topic));
                });

            }


            if(this.props.course !== undefined){
                courses.forEach(function(part, index, theArray) {
                    courses[index].worksheets = courses[index].worksheets.filter(obj => obj.topic === this.props.topicFilter);
                });
            }

            courses = courses.filter(c => c.worksheets.length > 0);


            this.setState({
                isFetching: false,
                courses: courses
            })
        } catch (e) {
            console.log(e);
            this.setState({
                isFetching: false,
                courses: []
            })
        }
    }

    onWorksheetsUpdated(updatedWorksheets){
        let allworksheets = [];
        Object.keys(updatedWorksheets).map((course, sectionIndex) => {
            updatedWorksheets[course].map((w) => {
                allworksheets.push(w);
            });
        });
        this.setState({
            worksheets: allworksheets
        });
    }


    render() {

        if(this.state.isFetching){
            return <LoadingScreen/>;
        }


        if(this.state.courses.length === 0){
            return (
                <PageContent>
                    {this.state.ltbView?
                        <CenteredMessage>
                        <FontAwesomeIcon icon={faFileWord} />
                        Du hast keine Arbeitsblätter
                    </CenteredMessage>
                        :
                        <CenteredMessage>
                            <FontAwesomeIcon icon={faFileWord} />
                            Keine Arbeitsblätter gefunden.
                        </CenteredMessage>
                    }
                </PageContent>
            )
        }

        return(
                <PageContent>
                <div className={"WorksheetsListPageForTrainee"}>
                        {this.state.courses.length > 0 && this.state.courses[0].worksheets.length > 0 && 
                        <>
                            <h2 className="px-3">{he.decode(this.state.courses[0].worksheets[0].trainee.firstname+" "+this.state.courses[0].worksheets[0].trainee.name)}</h2>
                        </>
                        }
                        {this.state.courses.map((course,idx)=>{
                            return(
                                <div key={"WorksheetsListPageForTrainee_div_"+idx}>
                                    {/*this.state.trainee.courses.find((obj) => obj._id === connectedTopic._id).name*/}
                                    <PradleAccordion title={<div><FontAwesomeIcon icon={faDiagramProject} /> {course.name}</div>} keyId={"topics"} open={(idx===0)}>
                                        <Row>
                                            <Col>
                                                <div className="p-2">
                                                    <h4><CourseTimespanBlock courseStartDateTime={course.start} courseEndDateTime={course.end} /></h4>
                                                </div>
                                            </Col>
                                             <div className='mb-2' style={{borderBottom:'1px solid #ccc',background:'#82c2ca', color:'white'}}>
                                                <BuildingRoomTable
                                                    items={course.schedules}
                                                    compactView   
                                                />
                                            </div>
                                            {course.worksheets.map((ws,idx)=>{
                                                if(ws.state === APIController.WORKSHEET_STATES.DISCARDED_WORKING_SHEET){
                                                    /* Hide worksheets, which are discardedQ */
                                                    //TODO: Put this filter operation in API, instead of frontend
                                                    return <></>;
                                                }
                                                return (
                                                 <Col xs={12} sm={6} lg={4} xl={3}>
                                                        <TopicKachel
                                                            isAzubiKachel={true}
                                                            topicId={ws.topic}
                                                            topicName={(ws.description.taskName!=="" && ws.description.taskName!==null)?ws.description.taskName:"Projekt "+ws.topic}
                                                            courseId={ws.courseId}
                                                            worksheets={[ws]}
                                                        ></TopicKachel>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                        <span className="px-2"><a href={UserController.getPortfolioCourseURL(course.worksheets[0].trainee._id,course._id)}><FontAwesomeIcon icon={faArrowRight} />Kursdetails</a></span>
                                    </PradleAccordion>

                                </div>
                            );
                        })}
                    </div>
                </PageContent>

            )

    }
}

export default WorksheetsListPageForTrainee;